interface RateLimitResult {
  allowed: boolean;
  retryAfter?: number;
  remaining?: number;
}

class VonRateLimiter {
  private requests: number[] = [];
  private readonly maxRequests = 30;
  private readonly windowMs = 60 * 1000;

  async checkRateLimit(): Promise<RateLimitResult> {
    const now = Date.now();
    
    // Remove requests outside the time window
    this.requests = this.requests.filter(time => now - time < this.windowMs);
    
    // Check if we've exceeded the rate limit
    if (this.requests.length >= this.maxRequests) {
      const oldestRequest = Math.min(...this.requests);
      const retryAfter = this.windowMs - (now - oldestRequest);
      
      return {
        allowed: false,
        retryAfter,
        remaining: 0
      };
    }
    
    // Add current request
    this.requests.push(now);
    
    return {
      allowed: true,
      remaining: this.maxRequests - this.requests.length
    };
  }

  getRemainingRequests(): number {
    const now = Date.now();
    this.requests = this.requests.filter(time => now - time < this.windowMs);
    return Math.max(0, this.maxRequests - this.requests.length);
  }

  getTimeUntilReset(): number {
    if (this.requests.length === 0) return 0;
    
    const now = Date.now();
    const oldestRequest = Math.min(...this.requests);
    return Math.max(0, this.windowMs - (now - oldestRequest));
  }
}

export const vonRateLimiter = new VonRateLimiter();
